import React from 'react';
import cn from 'classnames';

import './categorizerHeadingRowGroup.scss';

interface Props {
    separateRows?: boolean;
}

const CategorizerHeadingRowGroup: React.FC<Props> = ({
    separateRows = false,
    children,
}) => {
    return (
        <div
            styleName={cn('container', {
                'separated-rows': separateRows,
            })}
            className="__app-CategorizerHeadingRowGroup-container"
        >
            {children}
        </div>
    );
};

export default CategorizerHeadingRowGroup;
